import { render, staticRenderFns } from "./notify.template.vue?vue&type=template&id=dc0ea6d6&scoped=true&"
var script = {}
import style0 from "./notify.template.vue?vue&type=style&index=0&id=dc0ea6d6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0ea6d6",
  null
  
)

export default component.exports